export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '안전검사 대상 기계·기구 종류'},  {name: '작성자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContentStringList(func.getContent(value).typeTitleList) // 안전검사 대상 기계·기구 종류
      case 2: return func.getContent(value).stdInfo.writer_name // 작성자
      case 3: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '회사명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '안전검사 대상 기계·기구 종류': return ['content$body.typeTitleList*%[:default_skw]%']
    case '소속명': return ['content$body.stdInfo.department*%[:default_skw]%']
    case '부서명': return ['content$body.stdInfo.section*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }
  },
}
